import type { SharedLearnerProfile_PortfolioProjectsFragment as LearnerProfileProject } from 'bundles/account-profile/components/recruiting-profile-viewer/queries/__generated__/SharedLearnerProfile_portfolioProjects';
import type { SharedPortfolioProject_UserPortfolioProjectFragment as UserPortfolioProject } from 'bundles/portfolio-projects/queries/__generated__/SharedPortfolioProject_UserPortfolioProject';
import type { Nullable } from 'bundles/portfolio-projects/types';

export const mapLearnerProfileProjectToUserProject = (
  from: Nullable<LearnerProfileProject>,
  { isPublished }: { isPublished: boolean }
): Nullable<UserPortfolioProject> => {
  return from
    ? {
        __typename: 'UserPortfolioProject_Project',
        completed: from.completed,
        id: from.id,
        isPublished,
        lastUpdated: from.lastUpdated,
        linkToWork: from.linkToWork,
        project: {
          __typename: 'PortfolioProject_Project',
          title: from.title,
          id: from.id,
          slug: from.slug,
          image: from.image,
          tools: from.tools,
          skills: from.skills,
          occupationId: from.occupationId,
          businessChallenge: from.businessChallenge,
          estimatedWorkload: from.estimatedWorkload,
          isActive: false,
          projectType: from.projectType,
          partner: from.partner,
        },
        artifacts: from.artifacts?.map((art) => ({
          ...art,
          __typename: 'PortfolioProject_Artifact',
        })),
        isAutoPublished: from.isAutoPublished,
        summary: from.summary,
        approach: from.approach,
        solution: from.solution,
      }
    : null;
};

export const mapUserProjectToLearnerProfileProject = (from: UserPortfolioProject): LearnerProfileProject => {
  return {
    __typename: 'LearnerProfile_PortfolioProject',
    artifacts: from.artifacts?.map((art) => ({
      ...art,
      __typename: 'LearnerProfile_Artifact',
    })),
    businessChallenge: from.project.businessChallenge,
    completed: from.completed,
    estimatedWorkload: from.project.estimatedWorkload,
    id: from.project.id,
    image: from.project.image,
    lastUpdated: from.lastUpdated,
    linkToWork: from.linkToWork,
    occupationId: from.project.occupationId,
    skills: from.project.skills,
    slug: from.project.slug,
    title: from.project.title,
    tools: from.project.tools,
    projectType: from.project.projectType,
    partner: from.project.partner,
    isAutoPublished: from.isAutoPublished,
    summary: from.summary,
    approach: from.approach,
    solution: from.solution,
  };
};
